import { FC } from 'react'

import { isEmpty } from 'lodash'

import { useGetZendeskToken } from 'core/data'
import { useCompanyId } from 'core/hooks'

import { withErrorBoundary } from '../ErrorBoundary/ErrorBoundary'

import { UserDropdownLinkExternal } from './styled'

const UserPeachSupportLink: FC = () => {
  const companyId = useCompanyId()
  const [zendeskToken, zendeskTokenQuery] = useGetZendeskToken({
    companyId,
    options: {
      useErrorBoundary: true,
    },
  })

  if (isEmpty(zendeskToken)) return null

  return (
    <UserDropdownLinkExternal
      href={`https://peachfinance.zendesk.com/access/jwt?jwt=${zendeskToken}`}
      target='_blank'
      onClick={() => zendeskTokenQuery?.refetch()}
    >
      Peach support
    </UserDropdownLinkExternal>
  )
}

UserPeachSupportLink.displayName = 'PeachSupportLink'

export default withErrorBoundary(UserPeachSupportLink, {
  isAgent: true,
  ErrorFallback: () => null,
  ReportErrorFallback: () => null,
  PermissionsErrorFallback: () => null,
})
